export const MuiTextField = {
  styleOverrides: {
    root: {
      marginTop: 7,
    },
  },
};
